var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Homework/Final Exam")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document and replace all the highlighted fields with relevant information pertaining to your seminar. When finished, please submit a sharing link (with editing enabled) to the SL Portal. "
        )
      ]),
      _c(
        "Button",
        {
          staticClass: "btn-download mt-20",
          attrs: { skin: "grey" },
          on: { click: _vm.handleClickDownload }
        },
        [_vm._v("Homework Template")]
      ),
      _c("p", { staticClass: "text bold big mt-30" }, [
        _vm._v("Please paste the homework sharing link here and click submit.")
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: { counter: false, placeholder: "", value: _vm.value.link },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "link")
              }
            }
          })
        ],
        1
      ),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }